// Read-only compatibility with stored history. Never used to route or send messages.
export const LEGACY_IMPORTED_SOURCE = 'clerkchat_mirror';
export const LEGACY_IMPORTED_LABEL = 'Imported (legacy)';
export function importedBody(value) {
    return String(value || '').replace(/^(?:Attachment|Group text) — view in ClerkChat$/, 'Imported attachment (legacy)');
}

export const LEGACY_EVENT_TABLE = 'clerkchat_mirror_events';
export const stripLegacyProviderTag = (text) => text.replace(/^\s*\[ClerkChat\]\s*/i, '');
